import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-016b98ee")
const _hoisted_1 = { class: "text-xs text-gray-700 dark:text-custom-black-350" }
const _hoisted_2 = { class: "font-bold dark:text-gray-950 font-ops" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h6", { class: "mb-1" }, "Initial swap fee", -1)
const _hoisted_4 = { class: "text-custom-black-350" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "px-1" }, " % ", -1)
const _hoisted_6 = { class: "mb-1" }
const _hoisted_7 = { class: "mb-1" }
const _hoisted_8 = { class: "text-custom-black-350 mb-1" }
_popScopeId()

import { computed, ref, nextTick } from 'vue';

import useWeb3 from '@/services/web3/useWeb3';
import useNumbers from '@/composables/useNumbers';
import usePoolCreation from '@/composables/pools/usePoolCreation';

import { isRequired, isValidAddress } from '@/lib/utils/validations';
import { isAddress } from 'ethers/lib/utils';


export default _defineComponent({
  emits: ['update:height'],
  setup(__props, { emit }) {



/**
 * STATIC
 */
const FIXED_FEE_OPTIONS = ['0.001', '0.003', '0.01'];

/**
 * STATE
 */
const isCustomFee = ref(false);
const checkboxState = ref(true);
const isInvalidFee = ref(false);
const cardWrapper = ref<HTMLElement>();

/**
 * COMPOSABLES
 */
const { fNum2 } = useNumbers();
const {
  initialFee,
  feeController,
  feeManagementType,
  feeType,
  setFeeManagement,
  setFeeType,
  setFeeController,
  setTrpController,
  thirdPartyFeeController,
  fee,
  proceed,
  goBack,
  isLoadingSimilarPools
} = usePoolCreation();
const { account } = useWeb3();
const { userNetworkConfig } = useWeb3();

/**
 * COMPUTED
 */
const customInputClasses = computed(() => ({
  'border border-blue-500 text-blue-500': isCustomFee.value,
  'border dark:border-gray-900': !isCustomFee.value
}));

const isProceedDisabled = computed(() => {
  if (
    feeController.value === 'other' &&
    !isAddress(thirdPartyFeeController.value)
  ) {
    return true;
  }

  if (isInvalidFee.value) return true;

  return false;
});

// this does not need to be computed as it relies on a static
const feeOptions = FIXED_FEE_OPTIONS.map(option => {
  return {
    label: fNum2(option, {
      style: 'percent',
      minimumFractionDigits: 1,
      maximumFractionDigits: 1,
      fixedFormat: true
    }),
    value: option
  };
});

/**
 * FUNCTIONS
 */
function onFixedInput(val: string): void {
  initialFee.value = '0';
  initialFee.value = val;
  isCustomFee.value = false;
}

function onCustomInput(val: string): void {
  initialFee.value = (Number(val) / 100).toString();
  isCustomFee.value = true;

  if (Number(val) <= 0.0001 || Number(val) > 10) {
    isInvalidFee.value = true;
  } else {
    isInvalidFee.value = false;
  }
}

async function onChangeFeeManagementType(val: boolean) {
  if (!val) {
    setFeeManagement('self');
  } else {
    setFeeManagement('governance');
    setFeeType('fixed');
    setFeeController('self');
    setTrpController('');
  }
  await nextTick();
  emit('update:height', {
    height: cardWrapper.value?.offsetHeight || 0
  });
}

async function onChangeFeeType(val: string) {
  if (val === 'fixed') {
    setFeeController('self');
    setTrpController('');
  }
  await nextTick();
  emit('update:height', {
    height: cardWrapper.value?.offsetHeight || 0
  });
}

async function onChangeFeeController(val: string) {
  if (val === 'self') {
    setTrpController('');
  }
  await nextTick();
  emit('update:height', {
    height: cardWrapper.value?.offsetHeight || 0
  });
}

return (_ctx: any,_cache: any) => {
  const _component_BalIcon = _resolveComponent("BalIcon")!
  const _component_BalStack = _resolveComponent("BalStack")!
  const _component_BalBtnGroup = _resolveComponent("BalBtnGroup")!
  const _component_BalAlert = _resolveComponent("BalAlert")!
  const _component_BalCheckbox = _resolveComponent("BalCheckbox")!
  const _component_BalTooltip = _resolveComponent("BalTooltip")!
  const _component_BalRadio = _resolveComponent("BalRadio")!
  const _component_BalTextInput = _resolveComponent("BalTextInput")!
  const _component_BalBtn = _resolveComponent("BalBtn")!
  const _component_BalCard = _resolveComponent("BalCard")!

  return (_openBlock(), _createElementBlock("div", { ref: cardWrapper }, [
    _createVNode(_component_BalCard, {
      shadow: "xl",
      noBorder: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_BalStack, { vertical: "" }, {
          default: _withCtx(() => [
            _createVNode(_component_BalStack, {
              vertical: "",
              spacing: "xs"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_1, _toDisplayString(_unref(userNetworkConfig)?.name), 1),
                _createVNode(_component_BalStack, {
                  horizontal: "",
                  align: "center",
                  spacing: "xs"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("button", {
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(goBack) && _unref(goBack)(...args))),
                      class: "text-blue-500 hover:text-blue-700 flex"
                    }, [
                      _createVNode(_component_BalIcon, {
                        changeType: "createPool",
                        class: "flex",
                        name: "chevron-left"
                      })
                    ]),
                    _createElementVNode("h5", _hoisted_2, _toDisplayString(_ctx.$t('createAPool.setPoolFees')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_BalStack, {
              vertical: "",
              spacing: "sm"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _hoisted_3,
                  _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t('createAPool.bestFeeOption')), 1)
                ]),
                _createVNode(_component_BalStack, {
                  changeType: "createPool",
                  spacing: "xs",
                  horizontal: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_BalBtnGroup, {
                      options: _unref(feeOptions),
                      modelValue: _unref(initialFee),
                      "onUpdate:modelValue": [
                        _cache[1] || (_cache[1] = ($event: any) => (_isRef(initialFee) ? initialFee.value = $event : null)),
                        onFixedInput
                      ],
                      changeType: "createPool"
                    }, null, 8, ["options", "modelValue"]),
                    _createElementVNode("div", null, [
                      _createElementVNode("div", {
                        class: _normalizeClass(['custom-input', _unref(customInputClasses)])
                      }, [
                        _withDirectives(_createElementVNode("input", {
                          class: "w-12 text-right bg-transparent h-full",
                          "onUpdate:modelValue": [
                            _cache[2] || (_cache[2] = ($event: any) => (_isRef(fee) ? fee.value = $event : null)),
                            onCustomInput
                          ],
                          placeholder: "0.1",
                          type: "number",
                          step: "any"
                        }, null, 512), [
                          [_vModelText, _unref(fee)]
                        ]),
                        _hoisted_5
                      ], 2)
                    ])
                  ]),
                  _: 1
                }),
                (isInvalidFee.value)
                  ? (_openBlock(), _createBlock(_component_BalAlert, {
                      key: 0,
                      class: "w-full",
                      title: _ctx.$t('invalidFee'),
                      type: "error"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('invalidFeeExplain')), 1)
                      ]),
                      _: 1
                    }, 8, ["title"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_BalStack, {
              horizontal: "",
              spacing: "none",
              align: "center"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_BalCheckbox, {
                  "onUpdate:modelValue": [
                    onChangeFeeManagementType,
                    _cache[3] || (_cache[3] = ($event: any) => (checkboxState.value = $event))
                  ],
                  modelValue: checkboxState.value,
                  name: "areFeesGovernanceManaged",
                  size: "sm",
                  label: _ctx.$t('createAPool.governanceFees'),
                  noMargin: "",
                  changeType: "createPool",
                  color: "custom-blue-50"
                }, null, 8, ["modelValue", "label"]),
                _createVNode(_component_BalTooltip, {
                  text: _ctx.$t('createAPool.governanceFeesTooltip'),
                  "icon-size": "sm",
                  class: "ml-2 mt-1",
                  bgColor: "dark:bg-gray-850",
                  borderColor: "dark:border-custom-black-550"
                }, null, 8, ["text"])
              ]),
              _: 1
            }),
            (_unref(feeManagementType) === 'self')
              ? (_openBlock(), _createBlock(_component_BalStack, {
                  key: 0,
                  vertical: "",
                  spacing: "sm"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("h6", _hoisted_6, _toDisplayString(_ctx.$t('createAPool.alternativeFeeManagement')), 1),
                    _createVNode(_component_BalRadio, {
                      modelValue: _unref(feeType),
                      "onUpdate:modelValue": [
                        _cache[4] || (_cache[4] = ($event: any) => (_isRef(feeType) ? feeType.value = $event : null)),
                        onChangeFeeType
                      ],
                      value: "fixed",
                      name: "feeManagementOptions",
                      changeType: "createPool"
                    }, {
                      label: _withCtx(() => [
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t('createAPool.fixedFeeRadioLabel')), 1)
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_BalRadio, {
                      modelValue: _unref(feeType),
                      "onUpdate:modelValue": [
                        _cache[5] || (_cache[5] = ($event: any) => (_isRef(feeType) ? feeType.value = $event : null)),
                        onChangeFeeType
                      ],
                      value: "dynamic",
                      name: "feeManagementOptions",
                      changeType: "createPool"
                    }, {
                      label: _withCtx(() => [
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t('createAPool.dynamicFeeRadioLabel')), 1)
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_unref(feeType) === 'dynamic')
              ? (_openBlock(), _createBlock(_component_BalStack, {
                  key: 1,
                  vertical: "",
                  spacing: "sm"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("h6", _hoisted_7, _toDisplayString(_ctx.$t('createAPool.setAnAddress')), 1),
                    _createVNode(_component_BalRadio, {
                      modelValue: _unref(feeController),
                      "onUpdate:modelValue": [
                        _cache[6] || (_cache[6] = ($event: any) => (_isRef(feeController) ? feeController.value = $event : null)),
                        onChangeFeeController
                      ],
                      value: "self",
                      name: "addressOption",
                      changeType: "createPool"
                    }, {
                      label: _withCtx(() => [
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t('createAPool.myAddressOption', [_ctx._shorten(_unref(account))])), 1)
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_BalRadio, {
                      modelValue: _unref(feeController),
                      "onUpdate:modelValue": [
                        _cache[7] || (_cache[7] = ($event: any) => (_isRef(feeController) ? feeController.value = $event : null)),
                        onChangeFeeController
                      ],
                      value: "other",
                      name: "addressOption",
                      changeType: "createPool"
                    }, {
                      label: _withCtx(() => [
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t('createAPool.customAddressOption')), 1)
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_unref(feeController) === 'other' && _unref(feeType) === 'dynamic')
              ? (_openBlock(), _createBlock(_component_BalStack, {
                  key: 2,
                  vertical: "",
                  spacing: "xs"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("h6", null, _toDisplayString(_ctx.$t('createAPool.customAddressTitle')), 1),
                    _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t('createAPool.customAddressInfo')), 1),
                    _createVNode(_component_BalStack, {
                      vertical: "",
                      spacing: "xs"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_BalTextInput, {
                          modelValue: _unref(thirdPartyFeeController),
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_isRef(thirdPartyFeeController) ? thirdPartyFeeController.value = $event : null)),
                          placeholder: "0xBA4...2069",
                          type: "text",
                          size: "sm",
                          validateOn: "blur",
                          rules: [
                _unref(isRequired)(_ctx.$t('A controller address')),
                _unref(isValidAddress)()
              ],
                          containerBg: "dark:bg-gray-850",
                          name: "customAddress",
                          changeType: "createPool"
                        }, null, 8, ["modelValue", "rules"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_BalBtn, {
              disabled: _unref(isProceedDisabled) || _unref(isLoadingSimilarPools),
              type: "submit",
              block: "",
              onClick: _unref(proceed),
              changeType: "createPool",
              color: "custom-blue-50"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('next')), 1)
              ]),
              _: 1
            }, 8, ["disabled", "onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 512))
}
}

})